import { render, staticRenderFns } from "./NotifyCustomers.vue?vue&type=template&id=5d13553d&"
import script from "./NotifyCustomers.vue?vue&type=script&lang=js&"
export * from "./NotifyCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports